import { z } from 'zod/v4';

export const PlatformFeatureDetailSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  isActive: z.number(),
  createdAt: z.coerce.date().nullable(),
  updatedAt: z.coerce.date().nullable(),
  createdByUserId: z.string().nullable(),
  updatedByUserId: z.string().nullable(),
  updatedByUserName: z.string().nullable(),
});

export type PlatformFeatureDetail = z.infer<typeof PlatformFeatureDetailSchema>;

export const NetworkGrantorSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
});

export type NetworkGrantor = z.infer<typeof NetworkGrantorSchema>;

export const PlatformFeatureSchema = PlatformFeatureDetailSchema.extend({
  enabledCompaniesCount: z.number(),
  isEnabledForCompany: z.boolean().optional(),
  companyPlatformFeatureUpdatedAt: z.coerce.date().nullable().optional(),
  /**
   * Linked companies that grant this feature to the scoped company even though
   * it has no toggle of its own. Only ever populated for the network-inherited
   * feature; empty everywhere else. `isEnabledForCompany` keeps meaning "has a
   * direct grant", so the toggle still writes exactly what it wrote before.
   */
  inheritedFrom: z.array(NetworkGrantorSchema).optional(),
});

export type PlatformFeature = z.infer<typeof PlatformFeatureSchema>;

export const PlatformFeaturesListQuerySchema = z.object({
  companyId: z.string().min(1).optional(),
});

export type PlatformFeaturesListQuery = z.infer<
  typeof PlatformFeaturesListQuerySchema
>;

export const EnabledPlatformFeatureSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
});

export type EnabledPlatformFeature = z.infer<
  typeof EnabledPlatformFeatureSchema
>;

export const PatchPlatformFeatureBodySchema = z.object({
  name: z.string().min(1).optional(),
  description: z.string().optional(),
  isActive: z.union([z.literal(0), z.literal(1)]).optional(),
  enableCompanies: z.array(z.string().min(1)).optional(),
  disableCompanies: z.array(z.string().min(1)).optional(),
});

export type PatchPlatformFeatureBody = z.infer<
  typeof PatchPlatformFeatureBodySchema
>;
